// Composite variant key: "Gusto / Formato" when both exist, otherwise
// just the single dimension present (gusto-only or formato-only).
export const variantKey = (flavor, size) => {
  const f = (flavor || "").trim();
  const s = (size || "").trim();
  if (f && s) return `${f} / ${s}`;
  if (f) return f;
  if (s) return s;
  return "";
};

// Builds the list of gusto×formato combinations for an admin order-item picker.
// Mirrors the same combo rules used in the product editor.
export const comboOptions = (product) => {
  const flavors = Array.isArray(product?.flavors) ? product.flavors : [];
  const sizes = Array.isArray(product?.sizes) ? product.sizes : [];
  if (flavors.length && sizes.length) {
    return flavors.flatMap((fl) => sizes.map((sz) => variantKey(fl, sz)));
  }
  if (flavors.length) return flavors.map((fl) => variantKey(fl, ""));
  if (sizes.length) return sizes.map((sz) => variantKey("", sz));
  return [];
};

// Looks up stock for a flavor+size combo with graceful fallback to legacy
// single-dimension keys (data saved before the combo key existed).
export const stockForVariant = (variantStock, flavor, size) => {
  const vs = variantStock || {};
  const comboKey = variantKey(flavor, size);
  if (comboKey && vs[comboKey] !== undefined) return vs[comboKey];
  if (flavor && vs[flavor] !== undefined) return vs[flavor];
  if (size && vs[size] !== undefined) return vs[size];
  return undefined;
};

// Price is driven ONLY by the formato (size); the gusto never changes it.
// Falls back to the product base price when the size has no dedicated price.
export const priceForSize = (product, size) => {
  const base = Number(product?.price) || 0;
  const pbs = product?.price_by_size || {};
  const s = (size || "").trim();
  if (s && pbs[s] !== undefined && pbs[s] !== null && pbs[s] !== "") {
    const n = Number(pbs[s]);
    if (!Number.isNaN(n) && n > 0) return n;
  }
  return base;
};

// Extract the formato (size) from a combo key ("Gusto / Formato" | "Formato" | "Gusto").
export const sizeFromVariant = (variant) => {
  const v = (variant || "").trim();
  if (!v) return "";
  return v.includes(" / ") ? v.split(" / ")[1].trim() : v;
};

// Resolve the price for a full combo variant key (used by admin order picker).
export const priceForVariant = (product, variant) =>
  priceForSize(product, sizeFromVariant(variant));
